export default {
  viewBox: "0 0 24 24",
  html: "<g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#6D7981\" d=\"M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16m0 2c3.308 0 6 2.692 6 6s-2.692 6-6 6c-3.309 0-6-2.692-6-6s2.691-6 6-6\"/><path fill=\"#DBDEDF\" d=\"M12 6c3.308 0 6 2.692 6 6h2a8 8 0 0 0-8-8z\"/></g>"
};